
import axios from 'axios'
import { apiORDSpost, urlORDS } from '../shared/api-functions'



const MODULO_IMPORTARXML = 'invoice/importxml/'
const MODULO_MANIFESTO_EVENTO = 'manifesto/evento/'
const MODULO_DOWNLOADXML = 'manifesto/downloadxml/'

export default {

  methods: {

        handleDownloadFile(manifesto){

            let filename = 'NFe'+manifesto.chnfe+'.xml'
            let filedata = manifesto.list_manifesto[0].xml

            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(filedata));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);

        },

        handleGerarNFXML (manifesto) {
            var self = this

            let filename = 'NFe'+manifesto.chnfe+'.xml'
            //let filedata = decodeURIComponent(manifesto.xml.replace(/\+/g,  " "));
            let filedata = unescape(manifesto.list_manifesto[0].xml.replace(/\+/g,  " "));

            var file = new File([filedata], filename, {type: "text/xml", lastModified: new Date()})

            let formData = new FormData()
            formData.append(file.name, file)
            axios.post(urlORDS(this.$store, MODULO_IMPORTARXML), formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
            ).then(function(response){
                    if (response.data.errmessages) {
                       self.$erpToastError('Erro na importação da XML: ' + response.data.errmessages[0])
                    } else {
                        let codnf = response.data.codnf
                        if (codnf)
                            self.$router.push('/nfentrada/'+codnf);
                    }
                })
                // .catch(function(response){
                    // self.$erpToastError(response.data.errmessages)
                // })

        },


        async EnviarEventoA1(manifesto, codevento, descevento, xjust, callback) {
            var sendData = {}
            sendData = { "codmanifesto": manifesto.list_manifesto[0].codmanifesto, "chave": manifesto.chnfe, "codevento": codevento, "descevento": descevento, "xjust": xjust }


            let metodo = 'post'

            const data = await apiORDSpost(this.$store, MODULO_MANIFESTO_EVENTO, sendData, metodo)
            if (data.errmessages) {
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            }
            callback("A1", !data.errmessages, manifesto, codevento);

        },

        EnviarEventoA3ResponseCallback(response, callback, manifesto, codevento) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message)
            } else {
                this.$erpToastSuccess('Evento realizado!')
            }
            callback("A3", response.status == 'success', manifesto, codevento);
        },

        async EnviarEventoA3(manifesto, codevento, descevento, xjust, callback) {
            this.$appLoading(true);

            let sendData = "&codmanifesto="+manifesto.list_manifesto[0].codmanifesto+"&codevento="+codevento+"&descevento="+descevento+"&xjust="+xjust;
            this.$executaExtensaoChromeA3(null, 'manifestoevento', function (response) {
                this.EnviarEventoA3ResponseCallback(response, callback, manifesto, codevento)
              }, sendData)

        },

        async EnviarEvento(manifesto, codevento, descevento, xjust, callback) {

            let tipo = this.$certificadoCheck(null)
            if (tipo == 'A1') {
                this.EnviarEventoA1(manifesto, codevento, descevento, xjust, callback)

            } else
            if (tipo == 'A3') {
                this.EnviarEventoA3(manifesto, codevento, descevento, xjust, callback)

            }

        },

        async DownloadxmlA1(manifesto, callback) {
            var sendData = {}
            sendData = { "codmanifesto": manifesto.list_manifesto[0].codmanifesto, "chave": manifesto.chnfe }

            let metodo = 'post'

            const data = await apiORDSpost(this.$store, MODULO_DOWNLOADXML, sendData, metodo)
            if (data.errmessages) {
                this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                // this.$erpToastSuccess('Operação executada com sucesso.')
            }

            callback("A1", !data.errmessages, manifesto);

        },

        DownloadxmlA3ResponseCallback(response, callback, manifesto) {
            //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
            if (response.status != 'success') {
                this.$erpToastError(response.message)
            } else {
                this.$erpToastSuccess('Download efetuado')
            }
            callback("A3", response.status == 'success', manifesto)
        },

        async DownloadxmlA3(manifesto, callback) {
            this.$appLoading(true);

            let sendData = "&codmanifesto="+manifesto.list_manifesto[0].codmanifesto;
            this.$executaExtensaoChromeA3(null, 'manifestodownloadxml', function (response) {
                this.DownloadxmlA3ResponseCallback(response, callback, manifesto)
              } , sendData)

        },

        async Downloadxml(manifesto, callback) {
            let tipo = this.$certificadoCheck(null)
            if (tipo == 'A1') {
                this.DownloadxmlA1(manifesto, callback)
            } else
            if (tipo == 'A3') {
                this.DownloadxmlA3(manifesto, callback)
            }

        },


  }
}





// WEBPACK FOOTER //
// ./src/api/api-manifesto.js